var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicSlashMobile = function SvgMicSlashMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.42 24.327A9.751 9.751 0 0 0 27.75 18v-4.237a1.125 1.125 0 0 0-2.25 0V18a7.5 7.5 0 0 1-1.327 4.26l1.247 2.066Zm-2.348-3.892a5.603 5.603 0 0 0 .553-2.434V8.25h-.012a5.625 5.625 0 0 0-9.877-3.294l9.336 15.478ZM18 25.501a7.5 7.5 0 0 0 1.865-.235l1.2 1.99a9.753 9.753 0 0 1-1.94.43v3.065H22.5a1.125 1.125 0 0 1 0 2.25h-9a1.125 1.125 0 1 1 0-2.25h3.375v-3.065a9.752 9.752 0 0 1-8.625-9.685v-4.237a1.125 1.125 0 0 1 2.25 0V18a7.5 7.5 0 0 0 7.5 7.5Zm0-1.876c.285 0 .564-.02.838-.062L12.375 12.85V18A5.625 5.625 0 0 0 18 23.626Zm7.846 8.668a1.125 1.125 0 1 0 1.927-1.162l-16.5-27.355a1.125 1.125 0 1 0-1.927 1.162l16.5 27.355Z",
    fill: "#fff",
    fillOpacity: 0.85
  })));
};
export default SvgMicSlashMobile;